<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="配送日期" prop="distr_date">
          <el-date-picker
            v-model="table.params.distr_date"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :clearable="false"
            @change="onSearch"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品搜索" prop="goods_name">
          <el-input
            size="mini"
            v-model.trim="table.params.goods_name"
            placeholder="请输入"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="merchant_id">
          <el-select
            v-model="table.params.merchant_id"
            filterable
            placeholder="请输入"
            clearable
            @change="onSearch"
          >
            <el-option
              v-for="item in merchantArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="食堂名称" prop="address_id">
          <el-select
            v-model="table.params.address_id"
            filterable
            placeholder="请输入"
            clearable
            @focus="getStoreSel"
            @change="onSearch"
          >
            <el-option
              v-for="item in storeArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px"
                >({{ item.merchant_name }})</span
              >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户地区" prop="city">
          <el-select
            v-model="table.params.city"
            clearable
            @focus="handleFocus"
            @change="onSearch"
          >
            <el-option
              v-for="item in supplierCityArr"
              :label="`${item.province_str}${item.city_str}`"
              :value="item.city"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh-right" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <VTable
      has-pagionation
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="false"
      showIndex
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:loss_rate="{ row }">
        <span>{{ row.loss_rate }}%</span>
      </template>
      <template v-slot:actual_num="{ row,$index }">
        <el-popover
              :ref="`popoverDom+${$index}`"
              placement="bottom"
              width="220"
              @show="handlePopover(row)"
              trigger="click">
              <el-form
                class="staff-from"
                :model='form.data'
                :rules="form.rules"
              >
                <el-form-item label="修改实际毛菜数量">
                  <el-input
                    placeholder="请输入"
                    v-model="form.data.actual_num"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
              <el-row type="flex" justify="center">
                <el-button type="primary" :loading="form.loading" :disabled="form.loading" @click="handleDate(row,$index)">确定</el-button>
              </el-row>
              <el-button slot="reference" type="text" style="color:#409eff" icon="el-icon-edit-outline">{{row.actual_num}}</el-button>
            </el-popover>
      </template>
    </VTable>
    <div id="forClosePop"></div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "sorterIndex",
  components: {
    VTable,
  },
  mixins: [mixinTable],
  data() {
    return {
      merchantArr: [],
      storeArr: [], // 食堂
      supplierCityArr: [],
      supplierArr: [],
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "address_name", label: "食堂名称", hidden: false },
        { name: "goods_name", label: "商品名称", hidden: false },
        { name: "unit_name", label: "单位", hidden: false },
        { name: "spec_name", label: "规格", hidden: false },
        { name: "loss_rate", label: "净菜损耗率", hidden: false },
        { name: "quantity", label: "下单数量", hidden: false },
        { name: "loss_num", label: "预估毛菜数量", hidden: false },
        { name: "actual_num", label: "实际毛菜数量", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          distr_date: "",
          goods_name: "",
          merchant_id: "",
          address_id: "",
          city: "",
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
      //修改毛菜数量
      form:{
        data:{
          actual_num:'',
        },
        loading:false,
        rules:{
          actual_num:[{ required: true, message: '请输入', trigger: 'blur' }]
        }
      }
    };
  },
  created() {
    const start = new Date().getTime() + 60 * 60 * 24 * 1000; // 默认明天
    this.table.params.distr_date = this.$moment(start).format("YYYY-MM-DD");
    this.getTimeCut();
    this.getTable();
    this.getMerchantSel();
    this.getSupplierSel();
  },
  methods: {
    //现在的时间跟今天做比较-如果是今天5点以前，往前推一天
    getTimeCut() {
      const currentTime = this.$moment();
      const cutoffTime = currentTime.set({hour:4, minute:59, second:59});
      if(currentTime.isBefore(cutoffTime)) {
      this.table.params.distr_date = this.$moment(this.table.params.distr_date).subtract(1, 'days').format("YYYY-MM-DD");
      }
    },
    getTable() {
      this.table.loading = true;
      this.$http
        .get("/admin/sorter_order/neat", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    handleFocus() {
      this.supplierCityArr = this.filterUniqueById(this.supplierArr);
    },
    filterUniqueById(arr) {
      const seen = new Set();
      return arr.filter((item) => {
        if (seen.has(item.city)) return false;
        seen.add(item.city);
        return true;
      });
    },
    // 删除
    remove(row) {
      this.setConfirm(`确认删除操作？`, { id: row.id }, "/admin/sorter/delete");
    },
    handlePopover(row) {
      this.form.data.actual_num = row.actual_num;
    },
    handleDate(row,index) {
      if(!this.form.data.actual_num) {
        this.$message.warning("请输入实际毛菜数量！")
        return
      };
      let params = {
        distr_date:this.table.params.distr_date,
        address_id:row.address_id,
        spec_id:row.spec_id,
        num:this.form.data.actual_num,
      }
      this.$http.post('/admin/sorter_order/setNeat',params)
      .then(res => {
        if(res.code === 1) {
          this.form.data.actual_num = '';
          this.$message.success("修改成功！");
          this.getTable();
          document.getElementById('forClosePop').click();
        }
      })
    }
  },
};
</script>
